module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/_mars-277f60f53952d48cd5dec7765c8a3d19.png";